import { makeStyles } from 'tss-react/mui';

export const useRuleDetailsStyles = makeStyles<void, 'cardActions' | 'dragHandleIcon'>()(
  (theme, _params, classes) => ({
    addHeaderButton: {
      flexShrink: 0,
    },
    addPositionRow: {
      marginTop: theme.spacing(2),
    },
    /**
     * Drag handle for reordering positions, sitting in the panel's padding just
     * outside the card's left edge and revealed on card hover. Only the glyph
     * fades; the span is always there to grab.
     */
    card: {
      border: `1px solid ${theme.appColors.rule}`,
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      gap: theme.spacing(2),
      minWidth: 0,
      padding: theme.spacing(2),
      position: 'relative',
    },
    // Pinned to the card's top-right corner and revealed on card hover, like
    // the delete icons on the rule rows.
    cardActions: {
      color: theme.appColors.secondaryType,
      display: 'flex',
      gap: theme.spacing(0.25),
      opacity: 0,
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      transition: 'opacity 120ms ease',
      zIndex: 1,
    },
    /**
     * Drag handle for reordering positions. The span covers the whole panel
     * gutter left of the card, so moving the cursor off the card towards the
     * grip still counts as hovering the card and the grip stays visible until
     * it is reached. The glyph is centered on the card; grabbing anywhere in
     * the strip starts the drag.
     */
    dragHandle: {
      alignItems: 'center',
      bottom: 0,
      color: theme.appColors.secondaryType,
      cursor: 'grab',
      display: 'flex',
      justifyContent: 'center',
      left: -24,
      position: 'absolute',
      top: 0,
      width: 24,
    },
    // Only the glyph fades, so the hit area above stays in place at rest.
    dragHandleIcon: {
      opacity: 0,
      transition: 'opacity 120ms ease',
    },
    field: {
      fontSize: 14,
      width: '100%',
    },
    fieldGroup: {
      minWidth: 0,
    },
    fieldLabel: {
      alignItems: 'center',
      color: theme.appColors.iconsType,
      display: 'flex',
      fontSize: 13,
      fontWeight: 600,
      gap: theme.spacing(0.75),
      marginBottom: theme.spacing(0.5),
    },
    guidanceField: {
      fontSize: 14,
      width: '100%',
    },
    panel: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minWidth: 0,
    },
    panelContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      padding: theme.spacing(3),
    },
    panelHeader: {
      alignItems: 'center',
      backgroundColor: theme.appColors.background,
      borderBottom: `1px solid ${theme.appColors.rule}`,
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(1, 2),
    },
    panelTitle: {
      alignItems: 'center',
      color: theme.appColors.iconsType,
      display: 'flex',
      fontSize: 14,
      fontWeight: 600,
      gap: theme.spacing(0.75),
    },
    positionList: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    positionRow: {
      [`&:hover .${classes.cardActions}, &:hover .${classes.dragHandleIcon}`]: {
        opacity: 1,
      },
      display: 'flex',
      position: 'relative',
    },
    positionsHeader: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
      minWidth: 0,
      width: '100%',
    },
    positionsTitle: {
      alignItems: 'center',
      display: 'flex',
      gap: theme.spacing(0.75),
      minWidth: 0,
    },
    // The rule's name, styled like the title of a task in its details panel.
    titleDisplay: {
      color: theme.appColors.iconsType,
      fontSize: 24,
      fontWeight: 700,
      lineHeight: '30px',
    },
    titleInput: {
      fontSize: 24,
      fontWeight: 700,
      height: 'auto',
      lineHeight: '30px',
      padding: 0,
    },
    titlePlaceholder: {
      color: theme.appColors.secondaryType,
    },
  })
);
